import { request } from './api';
// import * as request from '@ge/shared/services/api';

export const getDamagesResult = (filters, options) =>
  request.post('/rei/damages/get-damages', filters, options);

export const fetchDamagesResult = (filters, options, damage, status, category) =>
  request.post('/rei/damages/fetch-damages', filters, options, damage, status, category);

export const fetchDamagesResultCount = (filters, options, damage, status) =>
  request.post('/rei/damages/fetch-damages-count', filters, options, damage, status);

export const getDamageReport = (data, options) =>
  request.post(`/rei/damages/damage-report`, data, options);

export const fetchDamageDetailsById = (damageId, options) =>
  request.get(`/rei/damages/damage-details/${damageId}`, options);

export const createPacCase = (data, options) =>
  request.post(`/rei/damages/create-pac-case`, data, options);

export const patchAnnotationJob = (annotationId, status) =>
  request.patch(`/rei/patchAnnotation/${annotationId}/metadata/status`, { status });

export const getExistingDamageDetailsByAssetId = (data) =>
  request.post(`/rei/damages/existing-damage-details`, data);

export const createNewDamage = (data, options) =>
  request.post(`/rei/inspection/create-new-damage`, data, options);

export const patchUpdateDamages = (data, options) =>
  request.patch(`/rei/inspection/patch-update-damage`, data, options);

export const fetchSiteOpenDamageDetails = (siteId, state) =>
  request.get(`/rei/damages/site-damages/${siteId}`, { params: { status: state } });
